define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'fnjimedia-detail/component/main',
    'css!vendor/font-awesome/css/font-awesome.min.css',
    'css!common/ub-page-reset.css',
    'css!common/ub-page-grid.css',
    'css!fnjimedia-detail/component/main.css'

], function(
    Vue,
    i18n,
    PageMixin,

    MainPage
){

    var app = new Vue({
        mixins: [PageMixin],
        components: {
            MainPage: MainPage
        },
        i18n: i18n
    });
    app.$mount('#app');


});


//////////////////
// WEBPACK FOOTER
// ./fnjimedia-detail/fnjimedia-detail.js
// module id = 121
// module chunks = 4